import { useContext, useState } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
import { useNavigate } from 'react-router-dom'
import { NewCardButton } from 'components/CardButtons'
import WORDING from 'constants/wording'
import { MeContext } from 'contexts/me'
import { requestNewCard } from 'api/credit-card'
import handleNotification from 'utils/toast/handleNotification'
import BlockCardModal from '../BlockCardModal'
import PhysicalCardButtons from './PhysicalCardButtons'

const { TARJETA_SOLICITADA } = WORDING

const cardButtonClasses =
  'text-purple-900 text-xs font-bold shadow-none border-gray-500 border'

const CardButtons = ({ typeCard, card, getCardData }) => {
  const [showModal, setShowModal] = useState(false)
  const navigate = useNavigate()
  const { successToast } = handleNotification()
  const { me } = useContext(MeContext)

  const { card_status: cardStatus } = card

  function handleCardBlock() {
    setShowModal(true)
    trackEvent({ eventName: 'bille_popup_tarjeta_bloquear' })
  }

  async function handleCardSolicitation() {
    await requestNewCard({
      wallet_user_uuid: me?.user?.uuid,
      card_type: typeCard
    })
    successToast(TARJETA_SOLICITADA)
    getCardData()
  }

  return (
    <>
      <div className='py-0 px-[24px] bg-white border border-solid border-gray-500 w-full box-border rounded-lg flex my-6' />
      {typeCard === 'PHYSICAL' ? <PhysicalCardButtons card={card} /> : null}

      {(cardStatus === 'ACTIVE' || cardStatus === 'BLOCKED') && (
        <NewCardButton
          onClick={() => {
            navigate('/cargar-dinero')
            trackEvent({
              eventName: 'bille_boton_cargar_dinero'
            })
          }}
          className={cardButtonClasses}
        >
          <span>Cargar dinero</span>
        </NewCardButton>
      )}

      {card?.card_status === 'ACTIVE' && (
        <NewCardButton
          onClick={() => {
            trackEvent({ eventName: 'bille_boton_tarjeta_bloquear' })
            handleCardBlock()
          }}
          className={cardButtonClasses}
        >
          <span>Bloquear / Denunciar</span>
        </NewCardButton>
      )}

      {typeCard === 'VIRTUAL' && card?.card_status === 'DISABLED' && (
        <NewCardButton
          onClick={() => handleCardSolicitation()}
          className={cardButtonClasses}
        >
          <span>Solicitar nueva tarjeta</span>
        </NewCardButton>
      )}

      {typeCard === 'VIRTUAL' &&
        card !== null &&
        Object.keys(card).length === 0 && (
          <NewCardButton
            onClick={() => handleCardSolicitation()}
            className={cardButtonClasses}
          >
            <span>Quiero mi tarjeta virtual</span>
          </NewCardButton>
        )}

      <BlockCardModal
        getCardData={getCardData}
        card={card}
        setShowModal={setShowModal}
        showModal={showModal}
      />
    </>
  )
}

export default CardButtons
